var Actions;
(function (Actions) {
    Actions["CREATE_MAIN_CATEGORY_LIST"] = "createMainCategoryList";
    Actions["DOWNLOAD_MAIN_CATEGORY"] = "downloadMainCategory";
    Actions["GET_MAIN_CATEGORY_LIST"] = "getMainCategoryList";
    Actions["GET_MAIN_CATEGORY_LIST_CODE_DESC"] = "getMainCategoryListCodeDesc";
    Actions["GET_MAIN_CATEGORY_LIST_FILTER"] = "getMainCategoryListFilter";
    Actions["GET_MAIN_CATEGORY_DATA"] = "getMainCategoryData";
    Actions["RESET_MAIN_CATEGORY_FILTER"] = "resetMainCategoryFilter";
    Actions["UPDATE_MAIN_CATEGORY_LIST"] = "updateMainCategoryList";
    Actions["UPDATE_SELECTED_MAIN_CATEGORY_CODE"] = "updateSelectedMainCategoryCode";
    Actions["UPDATE_SELECTED_MAIN_CATEGORY_DESC"] = "updateSelectedMainCategoryDesc";
    Actions["UPDATE_SELECTED_MAIN_CATEGORY_ACTIVE"] = "updateSelectedMainCategoryActive";
    Actions["UPDATE_MAIN_CATEGORY_SIZE"] = "updateMainCategorySize";
    Actions["UPDATE_MAIN_CATEGORY_PAGE_FILTER"] = "updateMainCategoryPageFilter";
    Actions["UPDATE_SEARCH_MAIN_CATEGORY_CODE"] = "updateSearchMainCategoryCode";
    Actions["UPDATE_SEARCH_MAIN_CATEGORY_DESC"] = "updateSearchMainCategoryDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_MAIN_CATEGORY_WAS_FIRST_LOAD"] = "setMainCategoryWasFirstLoad";
    Mutations["SET_MAIN_CATEGORY_LOADING"] = "setMainCategoryLoading";
    Mutations["SET_MAIN_CATEGORY_HANDLE_PAGE"] = "setMainCategoryHandlePage";
    Mutations["SET_MAIN_CATEGORY_LIST"] = "setMainCategoryList";
    Mutations["SET_MAIN_CATEGORY_LIST_CODE"] = "setMainCategoryListICode";
    Mutations["SET_MAIN_CATEGORY_LIST_DESC"] = "setMainCategoryListDesc";
    Mutations["SET_MAIN_CATEGORY_PAGE"] = "setMainCategoryPage";
    Mutations["SET_MAIN_CATEGORY_LOAD_PAGE"] = "setMainCategoryLoadPage";
    Mutations["SET_SELECTED_MAIN_CATEGORY_CODE"] = "setSelectedMainCategoryCode";
    Mutations["SET_SELECTED_MAIN_CATEGORY_DESC"] = "setSelectedMainCategoryDesc";
    Mutations["SET_SELECTED_MAIN_CATEGORY_ACTIVE"] = "setSelectedMainCategoryActive";
    Mutations["SET_MAIN_CATEGORY_STATUS"] = "setMainCategoryStatus";
    Mutations["SET_MAIN_CATEGORY_SIZE"] = "setMainCategorySize";
    Mutations["SET_MAIN_CATEGORY_USE_FILTER"] = "setMainCategoryUseFilter";
    Mutations["SET_MAIN_CATEGORY_PAGE_FILTER"] = "setMainCategoryPageFilter";
    Mutations["SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER"] = "setMainCategoryWasLoadQuickFilter";
    Mutations["SET_MAIN_CATEGORY_SEARCH_BY"] = "setMainCategorySearchBy";
    Mutations["SET_MAIN_CATEGORY_SEARCH_KEY"] = "setMainCategorySearchKey";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
